/* Hanezza home hero carousel — lightweight, two independent desktop/mobile sliders. */

!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{},n=(new e.Error).stack;n&&(e._sentryDebugIds=e._sentryDebugIds||{},e._sentryDebugIds[n]="bd2087df-34c4-5515-8015-03fb6c6fe346")}catch(e){}}();
(() => {
  'use strict';
  if (window.__hanezzaHeroSliderBooted) return;
  window.__hanezzaHeroSliderBooted = true;

  const instances = new WeakMap();
  const reducedMotion = window.matchMedia
    ? window.matchMedia('(prefers-reduced-motion: reduce)')
    : { matches: false, addEventListener() {}, removeEventListener() {} };

  function mount(root) {
    if (instances.has(root)) return;
    const slides = Array.from(root.querySelectorAll('[data-hz-hero-slide]'));
    if (slides.length < 2) return;
    const dots = Array.from(root.querySelectorAll('[data-hz-hero-dot]'));
    const previous = root.querySelector('[data-hz-hero-prev]');
    const next = root.querySelector('[data-hz-hero-next]');
    const interval = Math.min(30000, Math.max(3000, Number(root.dataset.autoplayDelay) || 6000));
    const links = slides.map(slide => Array.from(slide.querySelectorAll('a[href], button')));
    let current = 0;
    let timer = null;
    let visible = true;
    let paused = false;
    let touchStartX = null;
    let observer = null;

    function stop() {
      if (timer !== null) {
        window.clearInterval(timer);
        timer = null;
      }
    }
    function show(index) {
      current = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        const active = i === current;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        links[i].forEach(link => {
          if (!active) {
            if (!link.hasAttribute('data-hz-original-tabindex')) {
              link.setAttribute('data-hz-original-tabindex', link.getAttribute('tabindex') ?? '');
            }
            link.tabIndex = -1;
          } else if (link.hasAttribute('data-hz-original-tabindex')) {
            const previousValue = link.getAttribute('data-hz-original-tabindex');
            if (previousValue) link.setAttribute('tabindex', previousValue);
            else link.removeAttribute('tabindex');
            link.removeAttribute('data-hz-original-tabindex');
          }
        });
      });
      dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === current);
        dot.setAttribute('aria-pressed', i === current ? 'true' : 'false');
        dot.setAttribute('aria-label', 'Görsel ' + (i + 1) + ' / ' + slides.length);
      });
    }
    function canAutoPlay() {
      return !reducedMotion.matches && visible && !paused
        && document.visibilityState !== 'hidden' && root.isConnected;
    }
    function play() {
      stop();
      if (canAutoPlay()) timer = window.setInterval(() => show(current + 1), interval);
    }
    const onPrev = () => { show(current - 1); play(); };
    const onNext = () => { show(current + 1); play(); };
    const onMouseEnter = () => { paused = true; stop(); };
    const onMouseLeave = () => { paused = root.contains(document.activeElement); play(); };
    const onFocusIn = () => { paused = true; stop(); };
    const onFocusOut = event => {
      if (root.contains(event.relatedTarget)) return;
      paused = false;
      play();
    };
    const onKeyDown = event => {
      if (event.key === 'ArrowRight') { event.preventDefault(); onNext(); }
      if (event.key === 'ArrowLeft') { event.preventDefault(); onPrev(); }
    };
    const onVisibility = () => play();
    const onMotion = () => play();
    const onTouchStart = event => {
      touchStartX = event.changedTouches?.[0]?.screenX ?? null;
    };
    const onTouchEnd = event => {
      if (touchStartX === null) return;
      const endX = event.changedTouches?.[0]?.screenX;
      if (typeof endX !== 'number') return;
      const delta = endX - touchStartX;
      touchStartX = null;
      if (Math.abs(delta) < 45) return;
      if (delta < 0) onNext();
      else onPrev();
    };
    if (previous) previous.addEventListener('click', onPrev);
    if (next) next.addEventListener('click', onNext);
    const dotActions = dots.map((dot, i) => {
      const click = () => { show(i); play(); };
      dot.addEventListener('click', click);
      return click;
    });
    root.addEventListener('mouseenter', onMouseEnter);
    root.addEventListener('mouseleave', onMouseLeave);
    root.addEventListener('focusin', onFocusIn);
    root.addEventListener('focusout', onFocusOut);
    root.addEventListener('keydown', onKeyDown);
    root.addEventListener('touchstart', onTouchStart, { passive: true });
    root.addEventListener('touchend', onTouchEnd, { passive: true });
    document.addEventListener('visibilitychange', onVisibility);
    if (reducedMotion.addEventListener) reducedMotion.addEventListener('change', onMotion);
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(entries => {
        visible = Boolean(entries[0]?.isIntersecting);
        play();
      }, { threshold: 0.08 });
      observer.observe(root);
    }
    show(0);
    play();
    instances.set(root, {
      destroy() {
        stop();
        if (observer) observer.disconnect();
        if (previous) previous.removeEventListener('click', onPrev);
        if (next) next.removeEventListener('click', onNext);
        dots.forEach((dot, i) => dot.removeEventListener('click', dotActions[i]));
        root.removeEventListener('mouseenter', onMouseEnter);
        root.removeEventListener('mouseleave', onMouseLeave);
        root.removeEventListener('focusin', onFocusIn);
        root.removeEventListener('focusout', onFocusOut);
        root.removeEventListener('keydown', onKeyDown);
        root.removeEventListener('touchstart', onTouchStart);
        root.removeEventListener('touchend', onTouchEnd);
        document.removeEventListener('visibilitychange', onVisibility);
        if (reducedMotion.removeEventListener) reducedMotion.removeEventListener('change', onMotion);
        instances.delete(root);
      }
    });
  }
  function scan(scope) {
    if (scope.matches?.('[data-hz-hero-slider]')) mount(scope);
    scope.querySelectorAll?.('[data-hz-hero-slider]').forEach(mount);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => scan(document), { once: true });
  } else scan(document);
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:section:unload', event => {
    const nodes = [];
    if (event.target.matches?.('[data-hz-hero-slider]')) nodes.push(event.target);
    event.target.querySelectorAll?.('[data-hz-hero-slider]').forEach(node => nodes.push(node));
    nodes.forEach(node => instances.get(node)?.destroy());
  });
})();

//# debugId=bd2087df-34c4-5515-8015-03fb6c6fe346
